import React from "react";
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";

import {WideContent} from "@pg-design/grid-module";
import {flex, mb, mt, onDesktop, ph, underline} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {ArticleCategory, getSlugByArticleCategory} from "../../article/actions/ArticleCategory";
import {articleListBoxTitle, ArticleListBoxWide} from "../../article/components/article_list/ArticleListBoxWide";

export const InvestmentOfferArticles = () => {
    const articles = useSelector((state: IRPStore) => state.investmentOffer.articles);

    return (
        <WideContent css={investmentOfferArticles}>
            <Text align="center" css={[mb(3), onDesktop(mb(5))]} as="h2" variant="headline_3">
                <a css={underline} href={rpAppLink.article.category({categorySlug: getSlugByArticleCategory(ArticleCategory.Investments)})}>
                    Artykuły o inwestowaniu w nieruchomości
                </a>{" "}
                i trendy w inwestowaniu w nieruchomości
            </Text>

            {articles.map((article) => (
                <ArticleListBoxWide
                    article={article}
                    key={article.id}
                    articleTitle={
                        <Text css={articleListBoxTitle} as="h3" variant="headline_4">
                            {article.title}
                        </Text>
                    }
                />
            ))}
        </WideContent>
    );
};

const investmentOfferArticles = (theme: Theme) => css`
    ${flex()};
    flex-direction: column;
    ${mb(8)};
    row-gap: 2.4rem;
    ${mt(5)};

    @media (min-width: ${theme.breakpoints.md}) {
        row-gap: 1.6rem;
        max-width: 1128px;
        ${ph(0)};
    }
`;
import React from "react";
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";

import {WideContent} from "@pg-design/grid-module";
import {flex, mb, mt, onDesktop, ph, underline} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {ArticleCategory, getSlugByArticleCategory} from "../../article/actions/ArticleCategory";
import {articleListBoxTitle, ArticleListBoxWide} from "../../article/components/article_list/ArticleListBoxWide";

export const InvestmentOfferArticles = () => {
    const articles = useSelector((state: IRPStore) => state.investmentOffer.articles);

    return (
        <WideContent css={investmentOfferArticles}>
            <Text align="center" css={[mb(3), onDesktop(mb(5))]} as="h2" variant="headline_3">
                <a css={underline} href={rpAppLink.article.category({categorySlug: getSlugByArticleCategory(ArticleCategory.Investments)})}>
                    Artykuły o inwestowaniu w nieruchomości
                </a>{" "}
                i trendy w inwestowaniu w nieruchomości
            </Text>

            {articles.map((article) => (
                <ArticleListBoxWide
                    article={article}
                    key={article.id}
                    articleTitle={
                        <Text css={articleListBoxTitle} as="h3" variant="headline_4">
                            {article.title}
                        </Text>
                    }
                />
            ))}
        </WideContent>
    );
};

const investmentOfferArticles = (theme: Theme) => css`
    ${flex()};
    flex-direction: column;
    ${mb(8)};
    row-gap: 2.4rem;
    ${mt(5)};

    @media (min-width: ${theme.breakpoints.md}) {
        row-gap: 1.6rem;
        max-width: 1128px;
        ${ph(0)};
    }
`;
